import { useDependencies } from '@servicetitan/react-ioc';
import { FULLSTORY_API_TOKEN } from '../api/full-story.api';

export const useFullStory = () => {
    const [fullStoryApi] = useDependencies(FULLSTORY_API_TOKEN);
    return fullStoryApi;
};
